import { render } from "./expand.svg?vue&type=template&id=419bfc40"
const script = {}
script.render = render

export default script